<template>
  <div class="view" v-if="canEdit" v-cloak>
    <EditCreateTitleBox :label="title" />
    <PartnerAddOrEditContent
      ref="partnerAddOrEditContent"
      :partner-data="data"
      :can-edit="canEdit"
      :can-delete="canDelete"
      :save-and-new="true"
      @onSavePartner="savePartner"
      @onSaveAndNewPartner="saveAndNewPartner"
      @onDeletePartner="confirmDeletePartner"
      @onGotoListPartner="gotoListPartner"
    >
    </PartnerAddOrEditContent>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { canDelete, canEdit, permissions, permissionTypes } from "@/helpers/Permissions";
import * as actions from "@/helpers/generalActions";
import Forbidden from "@/pages/errors/Forbidden";
import PartnerAddOrEditContent from "~/pages/stock-management/sm-partners/partials/PartnerAddOrEditContent.vue";
import EditCreateTitleBox from "@/components/Common/EditCreateTitleBox.vue";

export default {
  name: "SMPartnersDetails",
  components: {
    PartnerAddOrEditContent,
    Forbidden,
    EditCreateTitleBox,
  },
  data() {
    return {
      data: {
        uuid: null,
        name: null,
        id_number: null,
        nr_reg: null,
        partner_type: null,
        legal_form: null,
        is_active: 1,
        bank_data: [],
        contact_person_data: [],
        county: null,
      },
    };
  },
  computed: {
    ...mapGetters({}),
    name() {
      return this.$t("common.partners");
    },
    config() {
      return {
        permission: permissions.SM_PARTNERS,
        permission_type: permissionTypes.access,
        create: this.create,
        update: this.update,
        delete: this.delete,
        list_url: "/stock-management/sm-partners",
        confirm_delete: true,
      };
    },
    actions() {
      return actions;
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    title() {
      if (this.data.uuid) {
        return this.$t("stock_management.partners.edit");
      }
      return this.$t("stock_management.partners.create_new");
    },
  },
  methods: {
    ...mapActions({
      create: "smPartners/createSmPartner",
      update: "smPartners/updateSmPartner",
      delete: "smPartners/deleteSmPartner",
    }),
    gotoListPartner() {
      return actions.gotoList(this);
    },
    confirmDeletePartner() {
      return this.actions.confirmDelete(this);
    },
    savePartner(dataToSave) {
      this.data = dataToSave;
      return this.actions.save(this, this.config.list_url);
    },
    saveAndNewPartner(dataToSave) {
      this.data = dataToSave;
      this.actions.saveAndNew(this).then(() => {
        this.$refs.partnerAddOrEditContent.reset({
          uuid: null,
          name: null,
          id_number: null,
          nr_reg: null,
          partner_type: null,
          legal_form: null,
          is_active: 1,
          bank_data: [],
          contact_person_data: [],
          county: null,
        });
      });
    },
  },
  mounted() {
    this.actions.handleParams(this);
    if (this.$route.params.uuid && this.$route.params.uuid !== "add") {
      this.data.uuid = this.$route.params.uuid;
    }
  },
  watch: {
    $route: {
      handler: function (newVal) {
        this.actions.handleParams(this);
        if (this.$route.params.uuid && this.$route.params.uuid !== "add") {
          this.data.uuid = this.$route.params.uuid;
        }
      },
      deep: true,
    },
    permission: {
      handler: function (newVal) {
        this.permissionModule = newVal;
      },
      deep: true,
    },
  },
  validations() {
    return {
      data: {
        name: {
          required: true,
        },
        legal_form: {
          required: true,
        },
        id_number: {
          required: true,
        },
      },
    };
  },
};
</script>

<style scoped>
.view {
  height: calc(100% - 70px);
}

.partner-edit-card {
  width: 100%;
  height: 100%;
  padding-top: 10px !important;
  padding-left: 10px !important;
  padding-right: 5px !important;
  background-color: #f9f9f9 !important;
}
</style>
